import React, { Suspense } from "react";
import { useRoutes } from "react-router-dom";
// lazy load all the views

//Home
const Home2 = React.lazy(() => import("pages/home2"));

const loading = () => <div className=""></div>;

type LoadComponentProps = {
  component: React.LazyExoticComponent<() => JSX.Element>;
};

const LoadComponent = ({ component: Component }: LoadComponentProps) => (
  <Suspense fallback={loading()}>
    <Component />
  </Suspense>
);

const AllRoutes = () => {
  return useRoutes([
    { path: "/", element: <LoadComponent component={Home2} /> },
  ]);
};

export { AllRoutes };
